module.exports = __webpack_public_path__ + "static/group-2@3x-c8af73311606e23930ad0844a6b27baa.png";